export { default } from './AffiliatesCompanies';
